/**
 * If data returned from a Immutable.js operation is not null or undefined, this function will call
 * toJS on it to return the JavaScript-native representation for components to use. Else it will
 * return undefined.
 *
 * @param {object} data Immutable.js object or null / undefined
 */
export const optionalToJS = (data) => data ? data.toJS() : undefined;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/selectors/utils.js